import React, { ReactNode } from 'react';
import cx from 'classnames';

type Props = {
  className?: string;
  children?: ReactNode;
};

export const Panels = (props: Props) => {
  const { children, className } = props;
  return <div className={cx('man-ui panels', className)}>{children}</div>;
};
